import { createUseQueryHook } from './createUseQueryHook';

export const usePersonTravelPolicy = (personId: string, options: { isEnabled: boolean }) => {
    const { isEnabled } = options;

    return createUseQueryHook('get_person_travel_policy', { enabled: isEnabled })(personId);
};
